export const buildTrailerPayload = (formData) => ({
  book: 0,
  bookOks: 0,
  furn: 0,
  inspectionExpDate: formData.inspectionExpDate,
  locationID: formData.locationID || 0,
  misc: 0,
  miscOks: 0,
  oli: 0,
  rentalRemovalDate: formData.rentalRemovalDate,
  rentalStatus: formData.rentalStatus,
  rentalTrailerDate: formData.rentalTrailerDate,
  rollDoor: formData.rollDoor,
  soft: 0,
  softOks: 0,
  status: formData.status ?? '',
  trailerNumber: formData.trailerNumber?.toString() ?? '',
  unitRentalCompanyID: formData.unitRentalCompanyID || 0,
  unitSizeID: formData.unitSizeID || 0,
  vendorId: formData.vendorId ?? '',
});
